import store from "../controller/baseController";
import Enums from "../enums/enums";
import userInfo from "../function/userInfo";
import i18n from "../locales/i18n";
import UserService from "../service/user/userService";
let maxFileSize = 25;
let maxFileCountDefault = 10;
let fileTypeList = [
  ".pdf",
  ".png",
  ".jpg",
  ".gif",
  ".txt",
  ".csv",
  ".xlsx",
  ".docx",
  ".zip",
  ".rar",
  ".7z",
  ".jpeg",
  ".pptx",
  ".key",
  ".rdx",
  ".heic",
  ".heif"
];

function ValidateTrueImage(file, nameFileType) {
  return new Promise(async (resolve) => {
    if (nameFileType == ".png" || nameFileType == ".jpg" || nameFileType == ".jpeg") {
      let rawString = await ReadFileAsync(file);
      let image = new Image();
      image.src = rawString;

      image.onload = function() {
        if (image.height === 0 || image.width === 0) {
          resolve(false);
        }
        resolve(true);
      };
      image.onerror = function() {
        resolve(false);
      };
    } else {
      resolve(true);
    }
  });
}

function ReadFileFromUrlAsync(url) {
  return FetchFileBlob(url).then((blob) => ReadFileAsync(blob));
}

function ReadFileAsync(file) {
  return new Promise((resolve, reject) => {
    let reader = new FileReader();
    reader.onload = (e) => {
      resolve(e.target.result);
    };
    reader.onerror = () => {
      reject(new Error("Error reading the file"));
    };
    reader.readAsDataURL(file);
  });
}

async function GetFileSizeFromUrl(url) {
  try {
    const blob = await FetchFileBlob(url);
    return blob.size;
  } catch (error) {
    return 0;
  }
}

async function SizeTotalFromFileList(transactionFileList) {
  let sizeTransactionFileTotal = 0;
  for (let transactionFile of transactionFileList) {
    const sizeFile = await GetFileSizeFromUrl(transactionFile.fileFullUrl);
    const sizeInMb = sizeFile / (1024 * 1024);
    sizeTransactionFileTotal += sizeInMb;
  }
  return sizeTransactionFileTotal;
}

async function ValidateFileForAttachTransaction(transactionFileList, uploadDocumentList) {
  let countUploadDocumentTotal = 0;
  let countTransactionFileTotal = 0;
  let sizeUploadDocumentTotal = 0;
  let sizeTransactionFileTotal = 0;

  countUploadDocumentTotal = uploadDocumentList.length;
  countTransactionFileTotal = transactionFileList.length;

  if (countUploadDocumentTotal + countTransactionFileTotal > maxFileCountDefault) {
    return false;
  }

  sizeUploadDocumentTotal = await SizeTotalFromFileList(uploadDocumentList);

  if (sizeUploadDocumentTotal > maxFileSize) {
    return false;
  }

  sizeTransactionFileTotal = await SizeTotalFromFileList(transactionFileList);

  if (sizeUploadDocumentTotal + sizeTransactionFileTotal > maxFileSize) {
    return false;
  }

  return true;
}

function GetIconAndColorFile(fileType, fileName) {
  let icon = "";
  let color = "";
  if (fileType.includes("image")) {
    icon = "icon-file_img";
    color = "#6B70F2";
  } else if (fileType.includes("pdf")) {
    icon = "icon-file_pdf";
    color = "#F1502F";
  } else if (
    fileName.toLowerCase().includes(".xlsx") ||
    fileName.toLowerCase().includes(".xls")
  ) {
    icon = "icon-file_exel";
    color = "#2E8552";
  } else if (
    fileName.toLowerCase().includes(".csv")
  ) {
    icon = "fas fa-file-csv";
    color = "#FF9E40";
  } else if (
    fileName.toLowerCase().includes(".doc") ||
    fileName.toLowerCase().includes(".docx")
  ) {
    icon = "icon-file_word";
    color = "#236BB1";
  } else if (
    fileName.toLowerCase().includes(".ppt") ||
    fileName.toLowerCase().includes(".pptx")
  ) {
    icon = "icon-file_ppt";
    color = "#B93D24";
  } else if (
    fileName.toLowerCase().includes(".txt")
  ) {
    icon = "icon-file_text";
    color = "#3297ff";
  } else {
    icon = "fas fa-file-alt";
    color = "#6C6DF2";
  }
  return { icon: icon, color: color };
}
const MAX_PRIVATE_FILE_TOKEN_REFRESH = 2;
const PRIVATE_FILE_TIMEOUT = 30000;
const downloadOnlyFileTypeList = [".txt"];

const IsAzureBlobStorageUrl = (url) => {
  try {
    return new URL(url).hostname.endsWith(".blob.core.windows.net");
  } catch (error) {
    return false;
  }
};

const GetFileServiceBaseUrl = () => (process.env.VUE_APP_PeakFileService || "").replace(/\/$/, "");

const GetFileServiceRootUrl = () => GetFileServiceBaseUrl().replace(/\/file$/, "");

export const GetFileServiceUrlPrefix = () => {
  const base = GetFileServiceBaseUrl();
  return base ? base + "/" : "";
};

export const GetFileServiceUrl = (relativePath) => {
  const base = GetFileServiceBaseUrl();
  if (!base || !relativePath) return "";
  return base + "/" + String(relativePath).replace(/^\//, "");
};

export const IsPrivateFileUrl = (url) => {
  if (!url || url.startsWith("data:") || url.startsWith("blob:")) return false;
  const fileServiceRoot = GetFileServiceRootUrl();
  if (!fileServiceRoot) return false;
  return IsAzureBlobStorageUrl(url) || url.startsWith(fileServiceRoot);
};

export const ConvertFileUrlFromBlobStorageToFileService = (url) => {
  if (!url) return "";
  const base = GetFileServiceBaseUrl();
  if (!base || !IsAzureBlobStorageUrl(url)) {
    return url;
  }
  const { pathname, search } = new URL(url);
  return base + pathname + search;
};

export const GetFileNameFromUrl = (url) => decodeURIComponent((url || "").split("?")[0].split("/").pop() || "");

export const InsertMerchantIdToFileUrl = (url) => {
  if (!url || url.startsWith("data:") || url.startsWith("blob:")) return url;
  const fileServiceRoot = GetFileServiceRootUrl();

  const target = ConvertFileUrlFromBlobStorageToFileService(url);
  if (!fileServiceRoot || !target.startsWith(fileServiceRoot)) return url;

  const merchantId = userInfo.MerchantId();
  if (!merchantId) return target;

  let emi;
  try {
    emi = btoa(String(merchantId));
  } catch (error) {
    return target;
  }

  const [pathPart, queryPart] = target.split("?");
  const segments = pathPart.split("/");
  const filename = segments.pop();
  if (segments[segments.length - 1] !== emi) {
    segments.push(emi);
  }
  segments.push(filename);
  const rebuilt = segments.join("/");
  return queryPart ? rebuilt + "?" + queryPart : rebuilt;
};

const ShowCannotAccessFileAlert = () => {
  store.dispatch("SetAlertMessage", {
    alertMessage: i18n.t("Cannot_Access_Image_From_Link"),
    typeMessage: Enums.TypeComponentNoti.error,
  });
};

const RefreshAccessTokenForPrivateFile = async () => {
  const refreshResult = await UserService.DoGetNewAccessTokenByRefreshToken();
  if (refreshResult && refreshResult.status && refreshResult.status.IsSuccess()) {
    const keepLogin = userInfo.GetKeepLogin();
    userInfo.SetCookiesAccessToken(refreshResult.data.access_token);
    userInfo.SetCookiesRefreshToken(refreshResult.data.refresh_token, keepLogin);
    return true;
  }
  return false;
};

export const FetchWithTokenRefresh = async (url, options = {}) => {
  const fetchOptions = { ...options, credentials: "include" };
  let response = await fetch(url, fetchOptions);

  let refreshCount = 0;
  while (response.status === Enums.HttpStatusCode.Unauthorized && refreshCount < MAX_PRIVATE_FILE_TOKEN_REFRESH) {
    refreshCount += 1;
    let refreshed = false;
    try {
      refreshed = await RefreshAccessTokenForPrivateFile();
    } catch (error) {
      refreshed = false;
    }
    if (!refreshed) break;
    response = await fetch(url, fetchOptions);
  }

  if (response.status === Enums.HttpStatusCode.Unauthorized) {
    ShowCannotAccessFileAlert();
    throw new Error("Session expired - unable to load private file");
  }

  return response;
};

const fileBlobInFlight = new Map();

export const FetchFileBlob = (url) => {
  const isPrivate = IsPrivateFileUrl(url);
  const requestUrl = isPrivate ? ConvertFileUrlFromBlobStorageToFileService(url) : url;

  const pending = fileBlobInFlight.get(requestUrl);
  if (pending) return pending;

  const request = (isPrivate ? FetchWithTokenRefresh(requestUrl) : fetch(requestUrl))
    .then((response) => {
      if (!response.ok) {
        throw new Error("Failed to fetch file");
      }
      return response.blob();
    })
    .finally(() => fileBlobInFlight.delete(requestUrl));

  fileBlobInFlight.set(requestUrl, request);
  return request;
};

export const FetchPrivateFileObjectUrl = async (url) => {
  if (!url || !IsPrivateFileUrl(url)) return url || "";
  const blob = await FetchFileBlob(url);
  return URL.createObjectURL(blob);
};

const SanitizeFileName = (fileName) => {
  if (!fileName) {
    return "download";
  }
  return fileName
    .replace(/[<>:"/\\|?*]/g, "_")
    .replace(/\s+/g, "_")
    .substring(0, 255);
};

export const DownLoadFromUrl = async (fileUrl, fileName) => {
  if (!fileUrl) {
    ShowCannotAccessFileAlert();
    return;
  }
  let objectUrl = null;
  try {
    const isPrivate = IsPrivateFileUrl(fileUrl);
    const requestUrl = isPrivate ? ConvertFileUrlFromBlobStorageToFileService(fileUrl) : fileUrl;
    const fetchOptions = { method: "GET", signal: AbortSignal.timeout(PRIVATE_FILE_TIMEOUT) };
    const response = isPrivate
      ? await FetchWithTokenRefresh(requestUrl, fetchOptions)
      : await fetch(requestUrl, fetchOptions);

    if (!response.ok) {
      ShowCannotAccessFileAlert();
      return;
    }

    const blob = await response.blob();

    objectUrl = window.URL.createObjectURL(blob);
    const downloadLink = document.createElement("a");
    downloadLink.href = objectUrl;
    downloadLink.download = SanitizeFileName(fileName);
    downloadLink.style.display = "none";

    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  } catch (error) {
    ShowCannotAccessFileAlert();
  } finally {
    window.URL.revokeObjectURL(objectUrl);
  }
};

export const OpenOrDownloadFileUrl = (url) => {
  if (!url) return;
  const fileUrl = ConvertFileUrlFromBlobStorageToFileService(url);
  const fileName = GetFileNameFromUrl(fileUrl);
  if (downloadOnlyFileTypeList.some((fileType) => fileName.toLowerCase().endsWith(fileType))) {
    DownLoadFromUrl(fileUrl, fileName);
    return;
  }
  window.open(fileUrl);
};

export default {
  async ValidateUploadFile(
    file,
    fileType,
    fileList,
    fileCount,
    maxFileCount = maxFileCountDefault,
    allowedFileTypeList = null
  ) {
    let fileName = file.name;
    let fileTypeValidateList = allowedFileTypeList ? allowedFileTypeList : fileTypeList;
    if (fileName.length > 0) {
      let validateFileType = false;
      let nameFileType = "";
      let validateFileImage = true;
      for (let j = 0; j < fileTypeValidateList.length; j++) {
        let fileType = fileTypeValidateList[j];
        if (
          fileName.substr(fileName.length - fileType.length, fileType.length).toLowerCase() == fileType.toLowerCase()
        ) {
          nameFileType = fileType.toLowerCase();
          validateFileType = true;
          break;
        }
      }

      if (!validateFileType) {
        store.dispatch("SetAlertMessage", {
          alertMessage: i18n.t("Validate_Upload_File_Type", {
            filename: fileName,
            fileTypeList: fileTypeValidateList.join(", "),
          }),
          typeMessage: Enums.TypeComponentNoti.error,
        });
        return false;
      } else {
        validateFileImage = await ValidateTrueImage(file, nameFileType);
      }

      if (!validateFileImage) {
        store.dispatch("SetAlertMessage", {
          alertMessage: fileName + " " + i18n.t("Validate_Upload_File_True_Image"),
          typeMessage: Enums.TypeComponentNoti.error,
        });
        return false;
      }
    }

    if (file.size / 1024 / 1024 > maxFileSize) {
      store.dispatch("SetAlertMessage", {
        alertMessage: i18n.t("Validate_Upload_File_larger", { maxFileSize: maxFileSize }),
        typeMessage: Enums.TypeComponentNoti.error,
      });
      return false;
    }
    if (fileCount > maxFileCount) {
      store.dispatch("SetAlertMessage", {
        alertMessage: i18n.t("Validate_Upload_File_Count", { maxFileCount: maxFileCount }),
        typeMessage: Enums.TypeComponentNoti.error,
      });
      return false;
    }
    if (fileList && fileList.length > 0 && fileList.some((fileItem) => fileItem.fileName === file.name)) {
      store.dispatch("SetAlertMessage", {
        alertMessage: i18n.t("Validate_Upload_File_duplicate"),
        typeMessage: Enums.TypeComponentNoti.error,
      });
      return false;
    }
    if (file.size === 0) {
      store.dispatch("SetAlertMessage", {
        alertMessage: i18n.t("Upload_Fail_No_Content"),
        typeMessage: Enums.TypeComponentNoti.error,
      });
      return false;
    }
    return true;
  },
  ValidFilesSizeUpload(fileSize, totalFilesSize) {
    if (totalFilesSize - fileSize < 0) {
      store.dispatch("SetAlertMessage", {
        alertMessage: i18n.t("Validate_Upload_Total_Files_larger", { maxFileSize: maxFileSize }),
        typeMessage: Enums.TypeComponentNoti.error,
      });
      return false;
    }
    return true;
  },
  ValidateUploadFileForQRPaymentImage(file, fileList) {
    let fileName = file.fileName;
    let fileImageTypeList = [".png", ".jpg", ".jpeg"];

    if (fileName.length > 0) {
      let validate = false;
      for (let j = 0; j < fileImageTypeList.length; j++) {
        let fileType = fileImageTypeList[j];
        if (
          fileName.substr(fileName.length - fileType.length, fileType.length).toLowerCase() == fileType.toLowerCase()
        ) {
          validate = true;
          break;
        }
      }

      if (!validate) {
        store.dispatch("SetAlertMessage", {
          alertMessage: i18n.t("Validate_Upload_File_Type", {
            filename: fileName,
            fileTypeList: fileImageTypeList.join(", "),
          }),
          typeMessage: Enums.TypeComponentNoti.error,
        });
        return false;
      }
    }
    let maxSize = 3;
    if (file.size / 1024 / 1024 > maxSize) {
      store.dispatch("SetAlertMessage", {
        alertMessage: i18n.t("Validate_Upload_File_larger", { maxFileSize: maxSize }),
        typeMessage: Enums.TypeComponentNoti.error,
      });
      return false;
    }
    if (fileList.some((fileItem) => fileItem.fileName === file.name)) {
      store.dispatch("SetAlertMessage", {
        alertMessage: i18n.t("Validate_Upload_File_duplicate"),
        typeMessage: Enums.TypeComponentNoti.error,
      });
      return false;
    }
    return true;
  },
  async ReadFileAsync(file) {
    return await ReadFileAsync(file);
  },
  async ReadFileFromUrlAsync(url) {
    return await ReadFileFromUrlAsync(url);
  },
  async GetFileSizeFromUrl(url) {
    return await GetFileSizeFromUrl(url);
  },
  ValidateFileSizeSendETaxByEmail(fileSize) {
    const maxSize = 3;
    if (fileSize / 1024 / 1024 > maxSize) {
      store.dispatch("SetAlertMessage", {
        alertMessage: i18n.t("Validate_File_Size_Send_ETax_Email", { fileSize: maxSize }),
        typeMessage: Enums.TypeComponentNoti.error,
      });
      return false;
    }
    return true;
  },
  async ValidateFileForAttachTransaction(transactionFileList, uploadDocumentList) {
    return await ValidateFileForAttachTransaction(transactionFileList, uploadDocumentList);
  },
  async SizeTotalFromFileList(transactionFileList) {
    return await SizeTotalFromFileList(transactionFileList);
  },
  GetIconAndColorFile(fileType, fileName) {
    return GetIconAndColorFile(fileType, fileName);
  },
};
